<template>
  <form @submit.prevent="save" class="w-m-content" v-if="!loading && !errors && !success">
    <div class="w-m-header">
      <div class="flex">
        <p class="font-14 font-bold no-margin col-grow" style="color: #293e52">Publicação do Blog</p>
        <div class="">
          <!--<u-btn size="sm" flat label="Variáveis" icon="eye" icon-type="fa" @click="$refs.vars.show()" />-->
        </div>
      </div>
      <!--<div class="m-t-xs font-13 text-grey-7" style="color: #748396; padding-right: 20px; line-height: 1">Esta seção
        autoriza uma pessoa a acessar o software, com suas respectivas permissões.
      </div>-->
    </div>
    <div class="w-m-body e-input-modern flex">
      <div style="min-height: 400px" class="flex column w-full">
        <e-row class="m-b-sm font-bold">
          Título:
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input autofocus simple-border required placeholder="Ex.: Sobre nós"
                       v-model="model.title" />
          </e-col>
        </e-row>

        <e-row class="m-b-sm font-bold">
          Descrição:
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input simple-border
                       v-model="model.description" />
          </e-col>
        </e-row>

        <e-row class="m-b-sm font-bold">
          Redirecionar (URL):
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input simple-border
                       v-model="model.url" />
          </e-col>
        </e-row>

        <e-row v-show="!source" class="m-b-sm m-t col-grow flex">
          <e-col class="flex col-grow column">
            <div class="m-b font-bold w-full flex-zero">Conteúdo da publicação:</div>
            <div style="margin: 0 -10px" class="doc-editor bg-white wrapper">
              <!--        <text-editor toolbar-position="top-outside"/>-->
              <sl-editor
                  ref="editor"
                  v-model="model.template"
                  placeholder="Faça uma anotação, @nome..."
                  :show-toolbar-on-focus="true"
                  :close-click-outside="false"
                  @focus="() => { textEditing = true }"
              />
            </div>
          </e-col>
        </e-row>
        <e-row v-show="source">
          <e-col>
            <textarea class="w-full wrapper-sm" rows="10" v-model="model.template" />
          </e-col>
        </e-row>
        <div class="flex items-center">
          <u-toggle v-model="source" class="m-r-sm" />
          Editar código fonte
        </div>
        <div class="flex items-center m-t">
          <u-toggle v-model="model.active" class="m-r-sm" />
          Publicado
        </div>
        <e-row class="m-t">
          <e-col style="max-width: 200px">
            <imagem label="Capa da publicação" legend="De preferência PNG 200x80px" ref="imagem" :image="model.image"
                    @update="updateImagem" @toDelete="deleteImagemEvent" />
          </e-col>
        </e-row>


      </div>
    </div>
    <div class="w-m-footer text-right">
      <u-btn @click="excluir" v-if="id && !model.interno" label="Excluir" no-caps color="negative"
             class="b-radius-3px pull-left" />
      <u-btn type="submit" :label="id ? 'Atualizar' : 'Cadastrar'" :disable="!ready" no-caps
             :color="ready ? 'primary' : 'blue-grey-2'"
             class="b-radius-3px" />
    </div>
  </form>
  <window-success v-else-if="success">
    <div class="text-center">
      <u-icon name="check-circle" color="positive" type="fa" icon-style="solid" class="success-circle-140" />
    </div>
    <h5 class="m-t">Publicação criada com sucesso!</h5>
    <!--<div class="m-t text-blue-grey-7">
      Ela poderá ser utilizada em todo o sistema de templates/documentos.
    </div>-->
    <div class="text-center m-t">
      <timer-close-window ref="timer" @end="success = null" />
    </div>
  </window-success>
  <window-loading :errors="errors" :status="status" v-else />
</template>

<script>
import ERow from '../../../layout/components/Row'
import {ErpInput} from 'uloc-vue-plugin-erp'
import ECol from '../../../layout/components/Col'
import {UToggle} from 'uloc-vue'
import WindowSuccess from '../../../layout/window/Success'
import TimerCloseWindow from '../../../layout/window/TimerClose'
import WindowLoading from '../../../layout/window/Loading'
import {
  newPost as create,
  updatePost as update,
  find,
  deletePost as deleteConteudo,
  updateFotoCapa
} from '@/domain/blog/services'
import Imagem from '@/reuse/upload/Imagem'
import SlEditor from "components/layout/components/Editor";

let mock = {
  id: null,
  title: null,
  description: null,
  template: '',
  url: null,
  active: true
}

export default {
  name: 'PaginasWindowModern',
  components: {
    SlEditor,
    WindowLoading, TimerCloseWindow, WindowSuccess, ECol, ERow, ErpInput, UToggle, Imagem
  },
  props: ['props', 'id'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock)),
      loading: !!this.id,
      errors: null,
      success: false,
      status: null,
      source: false,
      textEditing: false,
      deleteImagem: false,
    }
  },
  mounted () {
    this.id && this.load()
  },
  computed: {
    mock () {
      return mock
    },
    ready () {
      let model = this.model
      return model.title && String(model.title).length > 2 && model.template && String(model.template).length > 1;
    }
  },
  methods: {
    load () {
      find(this.id)
        .then(response => {
          this.model = response.data
          this.loading = false
        })
        .catch(error => {
          this.alertApiError(error)
          this.loading = false
        })
    },
    excluir () {
      this.$uloc.dialog({
        title: `Tem certeza que deseja excluir esta página?`,
        message: 'Digite EXCLUIR e clique para confirmar:',
        prompt: {
          model: '',
          type: 'text' // optional
        },
        cancel: true,
        color: 'negative'
      }).then(data => {
        if (data.toUpperCase() !== 'EXCLUIR') {
          this.$uloc.notify({
            color: 'negative',
            message: `Você não confirmou a operação. Exclusão não efetuada.`
          })
          return
        }
        this.$uloc.notify({
          color: 'negative',
          message: `Excluindo template...`
        })
        deleteConteudo(this.id)
          .then(response => {
            this.$uloc.notify({
              color: 'positive',
              message: `Página deletada com sucesso!`
            })
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.$uloc.window.close(this.$root.wid)
          })
          .catch(error => {
            this.alertApiError(error)
          })
      }).catch(() => {
      })
    },
    save () {
      console.log('Save')
      this.loading = true

      let data = this.model
      data.template = this.$refs.editor.htmlContent()

      let method = this.id ? (data) => update(this.id, data) : create
      method(data)
        .then(({data}) => {
          this.model.id = data.id
          const cbSuccess = () => {
            this.success = true
            this.loading = false
            Object.assign(this.model, data)
            this.$nextTick(() => {
              this.$uloc.window.emit(this.$root.wid, 'created', this.props)
              this.$refs.timer.start()
            })
          }
          // Processa foto
          if (this.deleteFoto) {
            console.log('Deleta Foto')
          } else if (this.$imagem) {
            this.status = 'Analisando e processando capa'
            updateFotoCapa(this.model.id, {data: this.$imagem, filename: 'foto'})
                .then(({data}) => {
                  cbSuccess()
                  delete this.$imagem
                })
                .catch((error) => {
                  alert('Impossível enviar a foto capa, mas os demais dados foram processados com sucesso!')
                  console.error(error)
                  cbSuccess()
                })
          } else {
            cbSuccess()
          }
        })
        .catch(error => {
          this.success = false
          this.errorMessage = error.data.message
          // this.errors = this.systemError(error)
          this.$nextTick(() => {
            this.loading = false
            this.alertApiError(error)
            // this.error = true
          })
        })
    },
    deleteImagemEvent () {
      this.deleteImagem = true
    },
    updateImagem (file) {
      this.$imagem = file
    }
  }
}
</script>
